<div class="sidebar-wrapper">

  <ul class="menu">
    @for (group of MENU_ITEMS_CONSTANTS; track group.name) {
      <li class="menu-group">
        <div class="group-title">{{ group.name }}</div>
        <ul class="submenu">
          @for (item of group.items; track item.route) {
            <li
              class="submenu-item"
              [class.active]="isActiveRoute(item.route)"
              [class.submenu-item--highlighted]="item.highlighted"
              (click)="internalNavigateTo(item.route)"
            >
              <i [class]="item.faIcon"></i>
              {{ item.name }}
            </li>
          }
        </ul>
      </li>
    }
  </ul>

  <div class="sidebar-footer">
    <div class="footer-links">
      <span class="footer-link" (click)="internalNavigateTo(APPLICATION_ROUTES_CONSTANTS.ROUTES.ABOUT_US)">About Us</span>
      <span class="footer-separator">·</span>
      <span class="footer-link" (click)="internalNavigateTo(APPLICATION_ROUTES_CONSTANTS.ROUTES.PRIVACY)">Privacy</span>
      <span class="footer-separator">·</span>
      <span class="footer-link" (click)="internalNavigateTo(APPLICATION_ROUTES_CONSTANTS.ROUTES.TERMS)">Terms</span>
    </div>
    <div class="version-info">
      version: {{ environment.version }}
    </div>
  </div>
</div>
